module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1011-7588cf611216c46dee59918c6f783cad.png";